/* eslint-disable max-statements */
import { useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const { vendors: { GET_VENDORS, GET_VENDOR_BY_ID } } = queries;
const { vendors: { DELETE_VENDOR, UPDATE_VENDOR } } = mutations;
const usePrepareComponent = () => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const { isAdmin, isEditor } = useUser();
    const { data, loading } = useQuery(GET_VENDOR_BY_ID, { fetchPolicy: "network-only", variables: { id: params.id } });
    const [updateVendor, { loading: isSaveLoading }] = useMutation(UPDATE_VENDOR, {
        refetchQueries: [{ query: GET_VENDOR_BY_ID, variables: { id: params.id } }]
    });
    const [deleteVendor] = useMutation(DELETE_VENDOR, {
        refetchQueries: [{ query: GET_VENDORS }]
    });
    const onCancel = () => {
        toggleIsEditing();
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onPublishToggle = () => {
        updateVendor({
            variables: {
                id: params.id,
                vendorUpdateInput: { isPublished: !data?.getVendorById.isPublished }
            }
        });
    };
    const onSave = (vendorUpdate, socialLinksUpdate) => {
        if (!params.id || !vendorUpdate.name || !vendorUpdate.slug)
            return;
        updateVendor({
            onCompleted: () => toggleIsEditing(),
            variables: {
                id: params.id,
                socialLinksUpdateInput: socialLinksUpdate,
                vendorUpdateInput: {
                    ...vendorUpdate
                }
            }
        });
    };
    const onDelete = () => {
        if (!params.id)
            return;
        deleteVendor({
            onCompleted: () => history.push("/vendors/vendors"),
            variables: { id: params.id }
        });
    };
    return {
        isAdmin,
        isEditing,
        isEditor,
        isSaveLoading,
        item: data?.getVendorById,
        loading,
        onCancel,
        onDelete,
        onEdit,
        onPublishToggle,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Item);
